export default __webpack_public_path__ + "static/media/dune_x_crayon_feat_ichon_2_lowdef.4227bb9f.png";